import { render, staticRenderFns } from "./BehaviorEditor.vue?vue&type=template&id=c25069dc&scoped=true&"
import script from "./BehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./BehaviorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25069dc",
  null
  
)

export default component.exports